import { NavigationMockApi } from 'app/mock-api/common/navigation/api';
import { IconsMockApi } from 'app/mock-api/ui/icons/api';

export const mockApiServices = [NavigationMockApi, IconsMockApi];
